export default __webpack_public_path__ + "static/media/product-4.3056bcb7.jpg";